export const ThreeLayerIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '19'}
    height={props?.height || '19'}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 13.25L9.08333 17.4167L17.4167 13.25M0.75 9.08333L9.08333 13.25L17.4167 9.08333M9.08333 0.75L0.75 4.91667L9.08333 9.08333L17.4167 4.91667L9.08333 0.75Z"
      stroke={props?.color || '#2E51CD'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
